import gsap from 'gsap'
import sleep from '../../helpers/sleep'

class Splash {
  constructor() {
    this.el_content = document.querySelector('.homepage-splash__content')
    this.el_firstProject = document.querySelector('.js-full-width-cta-slide')
    this.el_line = document.querySelector('.homepage-splash__line path')
    this.el_splash = document.querySelector('.js-homepage-splash')
    this.el_title = document.querySelector('.homepage-splash__title')
    this.el_cta = document.querySelector('.homepage-splash__cta')
    this.el_scrollanimation = document.querySelector(
      '.homepage-splash__scroll-animation'
    )
  }

  animateOnEntry() {
    let animations = {
      fadeInTitle() {
        return gsap.from(this.el_title, { opacity: 0, duration: 1 })
      },
      slideInLine() {
        return gsap.from(this.el_line, {
          x: '-100%',
          duration: 2,
          ease: 'sine.in',
        })
      },
      fadeInCta() {
        return gsap.to(this.el_cta, { opacity: 1, duration: 1 })
      },
      fadeInScrollAnimation() {
        return gsap.to(this.el_scrollanimation, { opacity: 1, duration: 1 })
      },
    }

    const tl = gsap.timeline()

    tl.add(animations.fadeInTitle.call(this))
    tl.add(animations.slideInLine.call(this), '-=0.3')

    if (this.el_cta) {
      tl.add(animations.fadeInCta.call(this), '-=0.3')
    }

    tl.add(animations.fadeInScrollAnimation.call(this), '-=0.3')
  }

  async init() {
    await sleep(100)
    this.unhideContent()
    this.animateOnEntry()
  }

  unhideContent() {
    gsap.set(this.el_content, { opacity: 1, duration: 0 })
  }
}

export default function init() {
  let splash = new Splash()
  splash.init()
}
